// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2t-1";
export var rateTableServiceLevelDropdown = "_2t-3";
export var rateTableTypeDropdown = "_2t-0";
export var rateTableValueModeDropdown = "_2t-2";